module.exports = __webpack_public_path__ + "img/B1AB22E6AA23D3ACD47BAD6C3EFD2BB9.89a93467.jpg";